import { cva } from 'class-variance-authority';

export const contentVariants = cva(
  'fixed top-[50%] left-[50%] z-50 grid w-full translate-x-[-50%] translate-y-[-50%] gap-4 border bg-white p-6 shadow-lg sm:rounded-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 duration-200',
  {
    variants: {
      width: {
        s: 'max-w-[480px]',
        m: 'max-w-[640px]',
        l: 'max-w-[1040px]',
      },
    },
    defaultVariants: {
      width: 'm',
    },
  },
);
